import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import FullContainerLanding from "@/pages/FullContainerLanding";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<FullContainerLanding />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
